import React from 'react';
import { connect } from "react-redux";
import style from './Footer.module.scss';
import {Container, Row, Col} from "react-bootstrap";
import logo from "../../asset/images/icon/logo.svg";
import homeFather from "../../asset/images/khosravi.png";

class FooterComponent extends React.Component {
  render() {
    return (
      <Container fluid className={`p-0 text-right ${style.footer_container}`}>
        <Row className={`${style.row}`}>
          <Col xs={12} md={12} lg={4} className={style.logo_container}>
            <div className={`d-flex flex-column align-items-center align-items-lg-start`}>
              <img src={logo} alt="logo" width={155} height={55} />
              <span className={`${style.description} d-inline-block text-center text-lg-right`}>
                هوم پلاک دغدغه‌های اجاره خانه در تهران را کاهش داده، و همراهی‌تان می‌کند تا بعد از دریافت اطلاعاتی جامع به بازدید خانه بروید. تصور کنید اگر قرار باشد بصورت حضوری به به بازدید خانه‌ها مراجعه کرده و خانه به خانه در جستجوی ملک دلخواه باشید چقدر باید زمان زیادی صرف کنید.
              </span>
              <ul>
                <li className={'d-flex align-items-center'}>
                  <i className={`${style.icon} icon-pin`} />
                  <span className={`${style.address}`}>خیابان فاطمی روبروی سازمان آب پلاک ۲۱۵</span>
                </li>
                <li className={'d-flex align-items-center'}>
                  <i className={`${style.icon} icon-phone`} />
                  <span className={`${style.address}`}>تلفن ۸۸۹۶۴۴۷۰-۰۲۱</span>
                </li>
                <li className={'d-flex align-items-center'}>
                  <i className={`${style.icon} icon-phone`} />
                  <span className={`${style.address}`}>تلفن ۸۸۹۷۲۵۶۸-۰۲۱</span>
                </li>
              </ul>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2} className={`text-center ${style.menu}`}>
            <div className={`d-flex flex-column align-items-center`}>
              <span className={`${style.title}`}>دسترسی سریع</span>
              <ul className={`${style.navigation}`}>
                <li><a href="#">خرید</a></li>
                <li><a href="#">رهن و اجاره</a></li>
                <li><a href="#">ثبت ملک</a></li>
                <li><a href="#">تماس با ما</a></li>
                <li><a href="#">درباره ما</a></li>
                <li><a href="/privacy">حریم خصوصی</a></li>
              </ul>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2} className={`text-center ${style.menu}`}>
            <div className={`d-flex flex-column align-items-center`}>
              <span className={`${style.title}`}>شبکه های اجتماعی</span>
              <ul>
                <li className={`d-flex align-items-center`}>
                  <i className={`${style.icon} icon-instagram`} />
                  <a href="#">اینستاگرام</a>
                </li>
                <li className={`d-flex align-items-center`}>
                  <i className={`${style.icon} icon-telegram`} />
                  <a href="#">تلگرام</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col xs={12} md={12} lg={4} >
            <div className={`${style.home_father} d-flex flex-column flex-lg-row align-items-center align-items-lg-start`}>
              <div className={style.image_container}>
                <img src={homeFather} alt="homeFather"/>
              </div>
              <div className={`d-flex flex-column text-center text-lg-right`}>
                <div>
                  <span className={style.name}>خسروی</span>&nbsp;
                  <span className={style.alias}>پدر املاک ایران</span>
                </div>
                <div className={`${style.description} text-center text-lg-right`}>
                  <span>
                    زیباترین زمان عمرم را در اتحادیه مشاوران املاک صرف کردم تا با نظارت بر کار همکارانم دریابم واسطه بودن تنها به مفهوم رساندن طرفین معامله به هم نیست بلکه در نهایت انصاف و با ارائه مشاوره ی درست به هر دو طرف ، موفق به قرار گرفتن در دقیقا وسط آنهاست نه مایل به یک طرف و انحراف از طرف دیگر ، شما با هوم پلاک میتوانید این موضوع را لمس کنید.
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className={`d-flex justify-content-center align-items-center ${style.copy_right}`}>
          تمامی حقوق مادی و معنوی متعلق به سایت هوم پلاک می باشد.
        </div>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(FooterComponent);
